// eslint-disable-next-line func-names
export default function () {
    return {
        page: {
            type: undefined,
            params: undefined,
        },
        isEntryDiag: false,
        focusedNode: undefined,
        user: undefined,
        isDebugMode: false,
        leftMenu: undefined,
        leftMenuActive: undefined,
        pageTitle: undefined,
        adminPageTitle: 'Обучаемые',
        slideTabs: undefined,
        slideTab: undefined,
        filterTag: undefined,
        filterProvider: undefined,
        lms: {
            loaded: false,
            diagType: '',
            useSso: false,
            ssoUrl: undefined,
        },
        exercisesData: [],
        isLightTheme: localStorage.getItem('is-light-mode') === '1',
        emulateInfo: {
            user: null,
            courseId: null,
            flowNum: null,
        },
        favoritesPages: [],
    };
}
